// DS: i6.17
import React from 'react';
import IconWrap from '../../IconWrap';
const AddGif = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21 3c.552 0 1 .403 1 .9v16.2c0 .497-.448.9-1 .9H3c-.552 0-1-.403-1-.9V3.9c0-.497.448-.9 1-.9h18zm-1 2H4v14h16V5zm-9 3v3h-1v-1H8v4h2v-1H9v-1h2v4H7v-1H6V9h1V8h4zm3 0v8h-2V8h2zm4 0v1h-1v3h1v1h-1v3h-2V8h3z",
        fillRule: "evenodd"
    })));
};
AddGif.displayName = 'AddGif';
export default AddGif;

//# sourceMappingURL=AddGif.js.map